import React from 'react';
import { graphql } from 'gatsby';
import AiSoftwareDevelopmentConsulting from 'views/AiSoftwareDevelopmentConsulting';
import { NavBar, PopupRedirect } from 'components';
import { pages } from 'config/pages';
import Layout from 'components/layout';
import config from '../../../meta/config';

const page = pages['ai-software-development-consulting'];
const { navColors } = page;
const url = `${config.siteUrl}/services/ai-software-development-consulting/`;
const canonical = `${url}`;

const ASDCPage = ({ data }) => {
  const { allArticles } = data || {};

  return (
    <Layout {...{ page, canonical, url }}>
      <NavBar color={navColors} />
      <PopupRedirect />
      <AiSoftwareDevelopmentConsulting allArticles={allArticles} />
    </Layout>
  );
};

export const pageQuery = graphql`
  query ASDCQuery {
    allArticles: allMarkdownRemark(
      sort: { order: DESC, fields: [frontmatter___settings___date] }
      filter: {
        frontmatter: {
          title: {
            in: [
              "What should every decision maker know about the Generative AI revolution?"
              "ChatGPT implementation: key takeaways from our internal projects"
              "Will ChatGPT replace the Google Search Engine?"
            ]
          }
        }
      }
    ) {
      ...markdownFields
      ...boxMarkdownFields
    }
  }
`;

export default ASDCPage;
